import {
    getLedControllerDeviceStatusDetails,
    setLEDControllerDisableMonitoringData
} from "../network/LEDControllerOverviewNetworkAPI";

export const LEDControllerOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_VIEW":
            getLedControllerDeviceStatusDetails(action.data.dispatcher)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "ADD_DEVICE_DATA":
            setLEDControllerDisableMonitoringData(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        case "SET_MONITORING_STATUS_LOADER":
            return {...state, monitoringStatusLoadingDevices: {...state.monitoringStatusLoadingDevices, [action.data.mac]: action.data.monitoringStatusLoading} }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/reducer/LEDControllerOverviewReducer.js